import { faFilter } from "@fortawesome/free-solid-svg-icons";
import classnames from "classnames";
import Icon, { SvgIconName } from "components/components/Icon/Icon";
import { IconSize } from "components/components/Icon/IconWrapper";
import featureFlags from "utils/featureFlags";

import { OldStyledFilterButton, StyledFilterButton } from "./style";

interface FilterButtonProps {
  buttonText: string;
  onClick: () => void;
  isActive?: boolean;
  className?: string;
  dataTestId?: string;
}

const StyledFilterButtonComponent = featureFlags.rebrand
  ? StyledFilterButton
  : OldStyledFilterButton;

export const FilterButton: React.FC<FilterButtonProps> = ({
  buttonText,
  onClick,
  isActive = false,
  className,
  dataTestId,
}) => (
  <StyledFilterButtonComponent
    type="button"
    onClick={onClick}
    className={classnames({ active: isActive }, className)}
    data-test-id={dataTestId}
  >
    <span>{buttonText}</span>
    <Icon
      iconName={featureFlags.rebrand ? SvgIconName.Filter : faFilter}
      size={IconSize.xSmall}
    />
  </StyledFilterButtonComponent>
);

export { StyledFilterButton };
